import React, { useState } from 'react';
import "./coursedetailpage.css";
// Replace these paths with your real image asset file links
import softwareTestingImg from "../../assets/newcouresimages/testing.webp";
import javaImg from "../../assets/newcouresimages/java.webp";
import pythonImg from "../../assets/newcouresimages/python.webp";
import dotnetImg from "../../assets/newcouresimages/dotnet.webp";
import devopsImg from "../../assets/newcouresimages/Devops.webp";
import awsImg from "../../assets/newcouresimages/aws.webp";
import azureImg from "../../assets/newcouresimages/Azure.webp";
import angularImg from "../../assets/newcouresimages/Angular.webp";
import uiuxImg from "../../assets/newcouresimages/uiux.webp";
import Popupboxbox from '../popupbox/Popupbox';


const courses = [
  {
    id: 1,
    title: "Software Testing Course",
    image: softwareTestingImg,
    description: "Selenium is an open-source tool that automates web browsers. Programming languages like Ruby, Java, Node JS, PHP, Perl, Python, and C#.",
    details: [
      { icon: "🕒", label: "Duration: 100+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-11+yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode-Online/Offline" }
    ],
    placement: "100% Placement assistance"
  },
  {
    id: 2,
    title: "Java Course",
    image: javaImg,
    description: "Java is a general purpose, class-based, object-oriented programming language designed for having lesser implementation dependencies. It is a computing platform for application development.",
    details: [
      { icon: "🕒", label: "Duration: 180+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor 10+yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode-Online/Offline" }
    ],
    placement: "100% Placement assistance"
  },
  {
    id: 3,
    title: "Python Course",
    image: pythonImg,
    description: "Python is a computer programming language often used to build websites and software, automate tasks, and conduct data analysis.",
    details: [
      { icon: "🕒", label: "Duration: 150+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-11+yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode-Online/Offline" }
    ],
    placement: "100% Placement assistance"
  },

  {
    id: 4,
    title: "Dotnet course",
    image: dotnetImg, // Replace with your image variable
    description: ".Net is a Microsoft web services strategy to connect information people, systems, and devices through software.",
    details: [
      { icon: "🕒", label: "Duration: 100+hrs" },
      { icon: "🗓️", label: "Weekdays -1 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-7+yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode Online/Offline" }
    ],
    placement: "100% Placement assistance"
  },
  {
    id: 5,
    title: "DevOps Course",
    image: devopsImg, // Replace with your image variable
    description: "DevOps is a set of practices, tools, and cultural philosophies.",
    details: [
      { icon: "🕒", label: "Duration: 100+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-10+yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode-Online/Offline" }
    ],
    placement: "100% Placement assistance"
  },
  {
    id: 6,
    title: "AWS Course",
    image: awsImg, // Replace with your image variable
    description: "Amazon Web Services are the world's most comprehensive and broadly adopted cloud platform, offering over 200 fully-featured services from data centers globally",
    details: [
      { icon: "🕒", label: "Duration: 150+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-10+yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode-Online/Offline" }
    ],
    placement: "100% Placement assistance"
  },
  {
    id: 7,
    title: "Azure Course",
    image: azureImg, // Replace with your image variable
    description: "Azure is a public cloud computing platform with solutions including Infrastructure as a service, Platform as a service, and software as a service that can be used for services such as analytics, virtual computing storage, networking, and much more.",
    details: [
      { icon: "🕒", label: "Duration: 150+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-6+ yrs experience" }
    ],
    placement: "100% Placement assistance"
  },
  {
    id: 8,
    title: "Angular JS Course",
    image: angularImg, // Replace with your image variable
    description: "Angular Js was a JavaScript-based open-source front-end web framework for developing single-page applications",
    details: [
      { icon: "🕒", label: "Duration: 150+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-10+ yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode-Online/Offline" }
    ],
    placement: "100% Placement assistance"
  },
  {
    id: 9,
    title: "UI/UX Course",
    image: uiuxImg, // Replace with your image variable
    description: "UX (User Experience) and UI (User interface) are two interdependent terms.",
    details: [
      { icon: "🕒", label: "Duration: 100+hrs" },
      { icon: "🗓️", label: "Weekdays -1 to 2 hrs" },
      { icon: "🗓️", label: "Weekend -5hrs" },
      { icon: "👤", label: "Mentor-10+ yrs experience" },
      { icon: "👥", label: "Training pattern- Real-time training" },
      { icon: "💻", label: "Mode-Online/Offline" }
    ],
    placement: "100% Placement assistance" // partially visible on screen edge
  }
];


function Coursedetailpage() {

  const [showModal, setShowModal] = useState(false);




  return (
    <>
       <section className="courses-section">
      <div className="courses-heading">
        <h2>
          Current Top 10 Trending courses are on Demand by the Hiring Companies
        </h2>
        <p>
          You don't have to struggle alone, you've got our assistance and help.
        </p>
      </div>

   

        <div className="courses-container">
          {courses.map((course) => (
            <div key={course.id} className="course-card">

              {/* Top Card Image Banner */}
              <div className="course-image-wrapper">
                <img src={course.image} alt={course.title} />
              </div>

              {/* Core Card Content Body */}
              <div className="course-card-content">
                <h3 className="course-title">{course.title}</h3>
                <p className="course-description">{course.description}</p>

                {/* Dynamic Metadata Attributes Rows */}
                <ul className="course-meta-list">
                  {course.details.map((detail, index) => (
                    <li key={index}>
                      <span className="meta-icon">{detail.icon}</span>
                      <span className="meta-label">{detail.label}</span>
                    </li>
                  ))}
                </ul>

                {/* Placement Tagline Highlight */}
                <div className="placement-tag">
                  {course.placement}
                </div>

                {/* Interaction Details Action Button */}
                <div className="card-action-container">
                  <button className="details-btn "

                    onClick={() => setShowModal(true)}>Get Course Details</button>
                </div>
              </div>

            </div>
          ))}
        </div>
      </section>
      <Popupboxbox isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default Coursedetailpage;